import { motion } from "framer-motion";
import { springPresets } from "@/lib/motion";
export function Header() {
  const today = new Date();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const dateStr = today.toLocaleDateString('tr-TR', options);
  return <header className="w-full bg-primary text-primary-foreground">
      {/* Top bar */}
      <div className="border-b border-white/20 py-2 px-4">
        <div className="max-w-6xl mx-auto flex justify-between items-center text-xs font-sans opacity-90">
          <span>Yayın Tarihi: 20 Nisan 2026</span>
          <span className="hidden sm:block">🇹🇷 Karlıtepe Ortaokulu Öğrencileri İçin Özel Dijital Gazete</span>
          <span>Sayı: 106</span>
        </div>
      </div>

      {/* Masthead */}
      <div className="py-8 px-4 text-center border-b-4 border-white">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={springPresets.gentle}>
          {/* Decorative stars */}
          <div className="flex justify-center gap-2 mb-3">
            {["★", "★", "★", "★", "★"].map((s, i) => <span key={i} className="text-yellow-300 text-lg">{s}</span>)}
          </div>

          <div className="text-primary-foreground/70 text-sm font-sans tracking-widest uppercase mb-2">
            Özel Baskı — 106. Yıl
          </div>

          <h1 className="text-4xl sm:text-6xl font-black text-white tracking-tight leading-none mb-2" style={{
          fontFamily: "'Merriweather', serif",
          textShadow: "2px 2px 0px rgba(0,0,0,0.3)"
        }}>
            23 NİSAN GAZETESİ
          </h1>
          <div className="text-xl sm:text-2xl text-yellow-200 font-semibold mt-2" style={{
          fontFamily: "'Merriweather', serif"
        }}>
            Ulusal Egemenlik ve Çocuk Bayramı
          </div>

          {/* Tagline */}
          <div className="mt-4 text-primary-foreground/80 text-sm max-w-lg mx-auto italic">
            "Egemenlik kayıtsız şartsız milletindir." — Mustafa Kemal Atatürk
          </div>
        </motion.div>
      </div>

      {/* Nav sections */}
      <div className="bg-white/10 py-2 px-4">
        <div className="max-w-6xl mx-auto flex justify-center gap-6 text-sm font-semibold">
          {["Tarihçe", "Zaman Çizelgesi", "İlginç Bilgiler", "Kutlama Haberleri", "Bilgi Yarışması"].map(item => <button key={item} onClick={() => {
          const id = item.toLowerCase().replace(/\s+/g, '-').replace('ç', 'c').replace('ş', 's').replace('ı', 'i').replace('ğ', 'g').replace('ö', 'o').replace('ü', 'u');
          document.getElementById(id)?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="hover:text-yellow-200 transition-colors cursor-pointer hidden sm:block text-white/90">
              {item}
            </button>)}
        </div>
      </div>
    </header>;
}